import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fill-height":"","fluid":""}},[_c(VContainer,[_c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"8"}},[_c('drillLibSingleView',{attrs:{"parentEditedItem":this.drillLib.edges[0].node}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }